import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "ตกลง",
    cancel: "ยกเลิก",
    loginRegister: "เข้าสู่ระบบ / ลงทะเบียน",
    userAgreement: "ข้อตกลงการใช้งาน",
    privacyPolicy: "นโยบายความเป็นส่วนตัว",
    notBound: "ยังไม่ได้ตั้งค่า",
  },
  tabbar: {
    home: "หน้าแรก",
    search: "ค้นหา",
    library: "คลังเกม",
    mine: "ของฉัน",
    badgeLogin: "เข้าสู่ระบบ",
    badgeUpgrade: "อัปเกรด",
  },
  login: {
    navTitle: "เข้าสู่ระบบ",
    welcome: "ยินดีต้อนรับสู่ {brand}",
    subtitle: "เข้าสู่ระบบด้วย SMS หรือใช้ WeChat / QQ",
    subtitleGlobal: "เล่นทันทีในฐานะผู้เยี่ยมชม หรือเข้าสู่ระบบด้วย Google",
    mobileLabel: "โทรศัพท์",
    mobilePlaceholder: "หมายเลขโทรศัพท์",
    codeLabel: "รหัส",
    codePlaceholder: "รหัส SMS",
    getCode: "รับรหัส",
    resendIn: "ส่งใหม่ใน {sec} วินาที",
    agreement:
      "หมายเลขที่ยังไม่ได้ลงทะเบียนจะสร้างบัญชีให้อัตโนมัติ การดำเนินการต่อถือว่าคุณยอมรับ{userAgreement}และ{privacyPolicy}",
    otherMethods: "เข้าสู่ระบบด้วยวิธีอื่น",
    guest: "ดำเนินการต่อในฐานะผู้เยี่ยมชม",
    wechat: "เข้าสู่ระบบด้วย WeChat",
    qq: "เข้าสู่ระบบด้วย QQ",
    google: "ดำเนินการต่อด้วย Google",
    telegram: "Continue with Telegram",
    facebook: "ดำเนินการต่อด้วย Facebook",
    wechatComingSoon: "เข้าสู่ระบบด้วย WeChat เร็ว ๆ นี้",
    qqComingSoon: "เข้าสู่ระบบด้วย QQ เร็ว ๆ นี้",
    googleComingSoon: "เข้าสู่ระบบด้วย Google เร็ว ๆ นี้",
    googleFailed: "เข้าสู่ระบบด้วย Google ล้มเหลว กรุณาลองอีกครั้ง",
    telegramFailed: "Telegram login failed, please try again",
    facebookComingSoon: "เข้าสู่ระบบด้วย Facebook เร็ว ๆ นี้",
    mobileInvalid: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    codeInvalid: "กรุณากรอกรหัสยืนยัน",
    codeSent: "ส่งรหัสแล้ว",
  },
  loginPrompt: {
    defaultMessage: "เข้าสู่ระบบเพื่อดูเกมของคุณ",
  },
  settings: {
    navTitle: "ตั้งค่า",
    loginPrompt: "เข้าสู่ระบบเพื่อจัดการการตั้งค่าบัญชี",
    nickname: "ชื่อเล่น",
    mobile: "โทรศัพท์",
    controller: "ตั้งค่าจอย",
    controllerDesc: "ความไวเมาส์ / สติ๊กขวา / สลับปุ่ม",
    about: "เกี่ยวกับ",
    clearCache: "ล้างแคชในเครื่อง",
    language: "ภาษา",
    editNickname: "แก้ไขชื่อเล่น",
    nicknamePlaceholder: "ชื่อเล่นใหม่",
    nickEmpty: "ชื่อเล่นห้ามว่างเปล่า",
    nickTooLong: "ชื่อเล่นยาวได้สูงสุด 16 ตัวอักษร",
    updated: "อัปเดตแล้ว",
    cacheCleared: "ล้างแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
    aboutTitle: "เกี่ยวกับ {brand}",
    aboutVersion: "เวอร์ชันเว็บ v{version}",
    aboutBody:
      "เกมคลาวด์ที่ให้คุณเล่นเกม AAA ได้ในเบราว์เซอร์ ทุกที่ทุกเวลา\nเนื้อหาเกมทั้งหมดเป็นลิขสิทธิ์ของผู้พัฒนาแต่ละราย",
  },
  subscription: {
    choosePlan: "เลือกแพ็กเกจ",
    included: "สิ่งที่ได้รับ",
    orderSummary: "สรุปคำสั่งซื้อ",
    total: "รวม",
    continue: "ดำเนินการต่อ",
    secureNote: "ชำระเงินปลอดภัย · ซื้อครั้งเดียว",
    navTitle: "อัปเกรด",
    unlockTitle: "ปลดล็อกสิทธิพิเศษสมาชิก",
    expired: "หมดอายุแล้ว",
    daysLeft: "เหลือ {days} วัน",
    validUntil: "ใช้ได้ถึง {time}",
    tagline: "ไม่ต้องเข้าคิว เล่นได้นานขึ้น ภาพคมชัดขึ้น",
    perDay: "ประมาณ {price}/วัน",
    recommended: "คุ้มที่สุด",
    currentLevel: "แพ็กเกจปัจจุบัน",
    footer:
      "นี่คือแพ็กสมาชิกแบบซื้อครั้งเดียว ระยะเวลาที่เลือกจะถูกเพิ่มหลังยืนยันการชำระเงิน และจะไม่ต่ออายุอัตโนมัติ",
    planVipMonth: "VIP รายเดือน",
    planSvipMonth: "SVIP รายเดือน",
    perkNoQueue: "ข้ามคิว",
    perkDailyFree: "เล่นฟรี 60 นาทีต่อวัน",
    perkHd: "ภาพคมชัด HD",
    perkAllVip: "สิทธิ VIP ทั้งหมด",
    perkUnlimited: "เล่นได้ไม่จำกัดเวลา",
    perk4k: "4K / 60fps",
    perkSupport: "บริการลูกค้าพิเศษ",
    cnPayComingSoon:
      "การชำระเงินผ่าน WeChat / Alipay บนเว็บกำลังจะมาเร็ว ๆ นี้ — กรุณาใช้แอปไปก่อน",
    intlPayComingSoon: "การชำระเงินผ่าน Stripe / PayPal เร็ว ๆ นี้",
    payProcessing: "กรุณาชำระเงินให้เสร็จและเปิดหน้านี้ไว้…",
    paySuccess: "ชำระเงินสำเร็จ — เปิดใช้สมาชิกแล้ว",
    payFailed: "ชำระเงินล้มเหลว กรุณาลองอีกครั้ง",
    payCancelled: "ยกเลิกการชำระเงินแล้ว",
    telegramExtraTimeUnavailable: "การซื้อเวลาเล่นใน Telegram จะเปิดให้ใช้หลังจากเพิ่มเวอร์ชัน Stars แล้ว",
    payUnconfirmed:
      "ยังไม่พบการยืนยันการชำระเงิน หากคุณชำระแล้ว สิทธิ์จะเข้าในไม่ช้า",
    payPopupBlocked:
      "หน้าต่างชำระเงินถูกบล็อก — กรุณาอนุญาตป๊อปอัปแล้วลองอีกครั้ง",
    loadPlansFailed: "โหลดแพ็กเกจล้มเหลว กรุณาลองอีกครั้ง",
    retry: "ลองอีกครั้ง",
  },
  download: {
    nav: "Download App",
    title: "Get the Starparks app",
    subtitle: "Play Starparks on your phone and purchase membership in the app.",
    androidDescription: "The Android app is available on Google Play.",
    googlePlay: "Get it on Google Play",
    iosDescription: "The iOS app is on its way.",
    comingSoon: "Coming soon",
    membershipUnavailable: "Membership is not available yet",
    membershipAppHint: "Membership purchases are not available on this website. Please use the app to purchase a membership.",
    goToDownload: "Go to download page",
  },
  app: {
    backToDesktop: "กลับสู่เดสก์ท็อป",
  },
  titles: {
    download: "Download App",
    home: "หน้าแรก",
    search: "ค้นหา",
    detail: "รายละเอียดเกม",
    library: "คลังเกม",
    category: "หมวดหมู่",
    mine: "ของฉัน",
    myGames: "เกมของฉัน",
    reviews: "รีวิว",
    gameVideos: "วิดีโอการเล่น",
    commentReplies: "ความคิดเห็น",
    saves: "เซฟ",
    subscription: "อัปเกรด",
    signIn: "เช็คอินประจำวัน",
    settings: "ตั้งค่า",
    controlSettings: "ตั้งค่าจอย",
    login: "เข้าสู่ระบบ",
    play: "กำลังเล่น",
  },
  home: {
    searchPlaceholder: "ค้นหาเกม",
    sectionDefault: "เกม",
    allGames: "เกมทั้งหมด",
    more: "เพิ่มเติม",
    empty: "ยังไม่มีอะไรที่นี่",
    latestOnline: "เกมใหม่",
    comingSoon: "เร็ว ๆ นี้",
    subscribe: "แจ้งเตือนฉัน",
    subscribed: "จองแล้ว",
    score: "คะแนน",
    subscribeSuccess: "จองสำเร็จ — จะแจ้งเตือนเมื่อเปิดให้เล่น",
  },
  nav: {
    home: "หน้าแรก",
    library: "คลังเกม",
    searchPlaceholder: "ค้นหาเกม",
    me: "ฉัน",
    guest: "ผู้เยี่ยมชม",
    profile: "โปรไฟล์",
    myGames: "เกมของฉัน",
    dailyCheckIn: "เช็คอินประจำวัน",
    renewMembership: "ต่ออายุสมาชิก",
    upgradeMembership: "อัปเกรดสมาชิก",
    settings: "ตั้งค่า",
    switchToMobile: "สลับเป็นมือถือ",
    logout: "ออกจากระบบ",
    logoutConfirm: "คุณแน่ใจว่าต้องการออกจากระบบ?",
    mobileVersion: "มือถือ",
    login: "เข้าสู่ระบบ",
  },
  library: {
    all: "ทั้งหมด",
    noMore: "ไม่มีเพิ่มแล้ว",
    loading: "กำลังโหลด…",
    noData: "ไม่มีข้อมูล",
    noGames: "ไม่มีเกม",
    noUpcoming: "ไม่มีเกมที่กำลังจะมา",
    emptyCategory: "ไม่มีเกมในหมวดนี้",
  },
  mine: {
    notLoggedIn: "ยังไม่ได้เข้าสู่ระบบ",
    loginSyncTip: "เข้าสู่ระบบเพื่อซิงค์สมาชิก รายการโปรด และประวัติเกม",
    loginSyncTipDesktop:
      "เข้าสู่ระบบเพื่อดูโปรไฟล์ สมาชิก การเช็คอิน และประวัติเกม",
    guest: "ผู้เยี่ยมชม",
    daysLeft: "เหลือ {n} วัน",
    expired: "หมดอายุแล้ว",
    renewBanner: "{level} จะหมดอายุในอีก {n} วัน — ต่ออายุตอนนี้ลด 30%",
    membershipExpiredRenew: "สมาชิกหมดอายุแล้ว — ต่ออายุเลย",
    membershipExpired: "สมาชิกหมดอายุ",
    membershipDaysLeft: "สมาชิกเหลือ {n} วัน",
    gameTime: "เวลาเล่น",
    minUnit: "นาที",
    dailyCheckIn: "เช็คอินประจำวัน",
    upgrade: "อัปเกรด",
    renew: "ต่ออายุ",
    upgradeMembership: "อัปเกรดสมาชิก",
    renewMembership: "ต่ออายุสมาชิก",
    membership: "สมาชิก",
    myCollection: "รายการโปรดของฉัน",
    collectedGames: "เกมที่บันทึกไว้",
    recentlyPlayed: "เล่นล่าสุด",
    gameHistory: "ประวัติเกม",
    settings: "ตั้งค่า",
    switchToDesktop: "สลับเป็นเดสก์ท็อป",
    accountAndPrefs: "บัญชีและการตั้งค่า",
    claimGameTime: "รับเวลาเล่น",
    bindPhone: "ผูกหมายเลขโทรศัพท์",
    bindPhoneDesc: "อัปเกรดเป็นบัญชีเต็มและซิงค์ข้ามอุปกรณ์",
    bindPhoneDescDesktop: "อัปเกรดเป็นบัญชีเต็ม ซิงค์ข้ามอุปกรณ์",
    resetGuest: "รีเซ็ตตัวตนผู้เยี่ยมชม",
    resetGuestDesc: "ล้างบัญชีผู้เยี่ยมชมนี้และเริ่มใหม่",
    resetGuestDescDesktop: "เริ่มใหม่ด้วยตัวตนใหม่",
    logout: "ออกจากระบบ",
    myGamesTitle: "เกมของฉัน",
    collectTab: "รายการโปรด",
    loginViewCollect: "เข้าสู่ระบบเพื่อดูเกมที่บันทึกไว้",
    noCollect: "ยังไม่มีเกมที่บันทึกไว้",
    loginViewHistory: "เข้าสู่ระบบเพื่อดูประวัติเกม",
    noHistory: "ยังไม่มีเกมที่เล่นล่าสุด",
    weekMon: "จ.",
    weekTue: "อ.",
    weekWed: "พ.",
    weekThu: "พฤ.",
    weekFri: "ศ.",
    weekSat: "ส.",
    weekSun: "อา.",
    alreadySignedToday: "เช็คอินวันนี้แล้ว",
    signSuccessReward: "เช็คอินแล้ว! +{n} นาที",
    signSuccess: "เช็คอินแล้ว",
    loginJoinCheckIn: "เข้าสู่ระบบเพื่อร่วมเช็คอินประจำวัน",
    claimed: "รับแล้ว",
    unclaimed: "พลาด",
    todayDone: "วันนี้ ✓",
    today: "วันนี้",
    dayN: "วันที่ {n}",
    signedToday: "เช็คอินวันนี้แล้ว",
    signNow: "เช็คอินเลย",
    checkInTip1: "เช็คอินทุกวันเพื่อรับเวลาเล่นฟรี",
    checkInTip2: "วันที่พลาดใช้เหรียญเช็คอินย้อนหลังได้ในหน้าเช็คอินย้อนหลัง",
    loggedOut: "ออกจากระบบแล้ว",
    resetGuestConfirm:
      "การดำเนินการนี้จะล้างบัญชีผู้เยี่ยมชมปัจจุบันและเริ่มใหม่ด้วยตัวตนใหม่ การสมัครสมาชิก รายการโปรด และประวัติที่ซื้อไว้จะหายทั้งหมด ดำเนินการต่อ?",
    resetGuestConfirmBtn: "รีเซ็ต",
    resetting: "กำลังรีเซ็ต…",
    resetDone: "รีเซ็ตแล้ว — กรุณาเข้าสู่ระบบอีกครั้ง",
  },
  reviews: {
    recommendRate: "แนะนำ",
    tooFew: "รีวิวยังน้อย",
    count: "{n} รีวิว",
    playFirst: "เล่นเกมก่อนจึงจะรีวิวได้",
    rateThis: "เล่นแล้ว? มารีวิวกัน",
    mine: "ของฉัน",
    edit: "แก้ไข",
    delete: "ลบ",
    report: "รายงาน",
    played: "เล่น {d}",
    contentEmpty: "เนื้อหารีวิวห้ามว่าง",
    editReview: "แก้ไขรีวิว",
    editDone: "อัปเดตแล้ว",
    published: "โพสต์รีวิวแล้ว",
    deleteTitle: "ลบรีวิว?",
    deleteConfirm: "ลบแล้วกู้คืนไม่ได้ ยืนยันลบรีวิวนี้?",
    deleted: "ลบแล้ว",
    reportTitle: "รายงาน",
    reportConfirm: "รายงานเนื้อหานี้? ทีมงานจะตรวจสอบ",
    reported: "รายงานแล้ว",
    deleteReplyTitle: "ลบการตอบกลับ?",
    deleteReplyConfirm: "ลบการตอบกลับนี้?",
    replyTo: "ตอบกลับ",
    viewAllReplies: "ดูการตอบกลับทั้งหมด {n} รายการ",
    loadMore: "โหลดเพิ่ม",
    allReplies: "การตอบกลับทั้งหมด ({n})",
    commentDeleted: "รีวิวนี้ถูกลบแล้ว",
    commentShielded: "รีวิวนี้ถูกซ่อน",
    replyDeleted: "การตอบกลับนี้ถูกลบแล้ว",
    replyShielded: "การตอบกลับนี้ถูกซ่อน",
  },
  detail: {
    svipRequiredMsg: "เกมนี้ต้องมีสิทธิ์ SVIP จึงจะเล่นได้",
    timeInsufficientMsg: "เวลาเกมไม่เพียงพอ กรุณาซื้อเวลาเกมก่อน",
    goBuy: "ซื้อเลย",
    thinkAgain: "คิดอีกที",
    navTitle: "รายละเอียดเกม",
    back: "กลับ",
    svipOnly: "เฉพาะ SVIP",
    vipOnly: "เฉพาะ VIP",
    freeMinutes: "ฟรี {n} นาที",
    saveManage: "เซฟ",
    saveManageDesc: "ดู / กู้คืนเซฟเก่าและเพิ่มหมายเหตุ",
    liveVideos: "วิดีโอการเล่น",
    more: "เพิ่มเติม",
    viewAll: "ดูทั้งหมด",
    viewAllCount: "ดูทั้งหมด {n}",
    intro: "เกี่ยวกับเกมนี้",
    screenshots: "ภาพหน้าจอ",
    controlMethod: "การควบคุม: ",
    playerReviews: "รีวิว",
    commentCount: "{n}",
    recommend: "แนะนำ",
    notRecommend: "ไม่แนะนำ",
    similarGames: "เกมที่คล้ายกัน",
    collect: "รายการโปรด",
    collected: "ในรายการโปรด",
    collectStar: "☆ รายการโปรด",
    collectedStar: "★ ในรายการโปรด",
    unfavorited: "นำออกจากรายการโปรดแล้ว",
    entering: "กำลังเข้า…",
    unlockSvip: "ปลดล็อกด้วย SVIP",
    unlockVip: "ปลดล็อกด้วย VIP",
    startGame: "เล่น",
    reviewCount: "{n} รีวิว",
    sortHot: "ยอดนิยม",
    sortNew: "ใหม่ล่าสุด",
    noMore: "ไม่มีเพิ่มแล้ว",
    playedHours: "เล่นไป {n} ชม.",
    report: "รายงาน",
    reportTitle: "รายงานความคิดเห็นนี้?",
    reportMessage: "ทีมงานจะตรวจสอบให้ ยืนยันการรายงาน?",
    reported: "รายงานแล้ว",
    noReviews: "ยังไม่มีรีวิว มาเป็นคนแรกกัน",
    writeReview: "เขียนรีวิว",
    reviewPlaceholder: "แบ่งปันประสบการณ์ของคุณ… (อย่างน้อย 5 ตัวอักษร)",
    reviewMinLength: "รีวิวต้องมีอย่างน้อย 5 ตัวอักษร",
    reviewSubmitted: "ส่งรีวิวแล้ว",
    publish: "เผยแพร่",
    commentDetail: "ความคิดเห็น",
    replyCount: "{n} การตอบกลับ",
    noReplies: "ยังไม่มีการตอบกลับ มาเป็นคนแรกกัน",
    reply: "ตอบกลับ",
    replyToUser: "ตอบกลับ {'@'}{name}",
    saySomething: "พูดอะไรสักหน่อย…",
    send: "ส่ง",
    sent: "ส่งแล้ว",
    videoCount: "{n} วิดีโอ",
    watchCount: "{k}k ครั้ง",
    noVideos: "ยังไม่มีวิดีโอ",
    videoUnavailable: "วิดีโอนี้เล่นไม่ได้ในขณะนี้",
    videoUnavailableDesc: "อาจเป็นคลิปเก่าที่ถูกนำออกแล้ว — ลองอันอื่นดู",
  },
  search: {
    placeholder: "ป้อนชื่อเกม",
    emptyHint: "ค้นหาด้วยชื่อเกมหรือพินอิน",
    history: "ค้นหาล่าสุด",
    clear: "ล้าง",
    noResults: "ไม่พบเกม",
  },
  misc: {
    savesTitle: "เซฟเกม",
    savesTitleNamed: "{name} - เซฟ",
    savesLoginPrompt: "เข้าสู่ระบบเพื่อดูเซฟเกมของคุณ",
    savesActiveHeading: "เซฟที่ใช้งานอยู่",
    savesUnnamed: "เซฟไม่มีชื่อ",
    savesEditRemark: "เปลี่ยนชื่อ",
    savesEmpty: "ยังไม่มีเซฟบนคลาวด์",
    savesEmptyHint: "เซฟที่สร้างในเกมจะซิงค์มาที่นี่โดยอัตโนมัติ",
    savesHistory: "ประวัติ",
    savesCount: "{n} เซฟ",
    savesCurrent: "ปัจจุบัน",
    savesCorrupted: "เสียหาย",
    savesRestore: "กู้คืน",
    savesNoHistory: "ไม่มีประวัติเซฟ",
    savesFooter:
      "เซฟถูกสร้างจากการบันทึกด้วยตนเอง / อัตโนมัติในเกม และซิงค์ขึ้นคลาวด์โดยอัตโนมัติ ขณะนี้ยังไม่รองรับการลบด้วยตนเอง (การบันทึกต่อในเกมจะเขียนทับเซฟที่เก่าที่สุด)",
    savesRemarkTitle: "แก้ไขหมายเหตุเซฟ",
    savesRemarkPlaceholder: "ตั้งชื่อเซฟนี้ เช่น \"จบบทที่ 1 แล้ว\"",
    savesSave: "บันทึก",
    savesAlreadyCurrent: "นี่คือเซฟปัจจุบันอยู่แล้ว",
    savesRestoreTitle: "กู้คืนเซฟ",
    savesRestoreConfirm:
      "กู้คืนเป็นเซฟนี้? ครั้งหน้าที่เปิดเกม จะเริ่มจาก \"{name}\"",
    savesSwitched: "สลับเป็นเซฟนี้แล้ว",
    savesSaved: "บันทึกแล้ว",
    ctrlNavTitle: "ตั้งค่าจอย",
    ctrlSave: "บันทึก",
    ctrlIntro:
      "ปรับความรู้สึกของเมาส์ / จอยที่นี่ การเว้นค่าใด ๆ ให้ว่าง / 0 จะใช้ค่าเริ่มต้นของเซิร์ฟเวอร์ในแต่ละเกม การเปลี่ยนแปลงมีผลกับทุกเกม",
    ctrlMouseSensitivity: "ความไวเมาส์",
    ctrlServerDefault: "ค่าเริ่มต้นเซิร์ฟเวอร์",
    ctrlMouseHint: "ในโหมดล็อก ระยะการเคลื่อนที่ = การเคลื่อนที่จริง × {n}%",
    ctrlStickSensitivity: "ความไวสติ๊กขวา",
    ctrlStickHint:
      "ความเร็วการเล็งสำหรับเกม FPS / แอ็กชัน สติ๊กซ้าย (การเคลื่อนที่) ไม่ได้รับผลกระทบ",
    ctrlPrimaryClick: "ปุ่มเมาส์หลัก",
    ctrlLeftPrimary: "ซ้ายเป็นหลัก",
    ctrlRightPrimary: "ขวาเป็นหลัก",
    ctrlPrimaryClickHint:
      "บางเกม (เช่น เกมอินดี้บางเกม) ยิงด้วยคลิกขวาตามค่าเริ่มต้นและต้องสลับ",
    ctrlResetDefault: "รีเซ็ต",
    ctrlSavedToast: "บันทึกแล้ว มีผลครั้งหน้าที่เปิดเกม",
    ctrlResetToast: "กู้คืนเป็นค่าของเซิร์ฟเวอร์แล้ว",
    savesUploading: "กำลังอัปโหลดเซฟ — กรุณาลองใหม่อีกสักครู่",
    savesCheckFailed: "ตรวจสอบสถานะเซฟไม่สำเร็จ — กรุณาลองใหม่",
  },
  play: {
    stageReady: "พร้อม",
    queueing: "กำลังรอคิว",
    queueJoining: "กำลังเข้าคิว…",
    queueAheadPrefix: "",
    queueAheadSuffix: "คนอยู่ก่อนหน้าคุณ",
    queueEta: "ประมาณ {n} วินาที",
    cancelReturn: "ยกเลิกและกลับ",
    back: "กลับ",
    retry: "ลองอีกครั้ง",
    goSubscribe: "อัปเกรด",
    entering: "กำลังเข้าเกม",
    vipCta: "อัปเกรดเป็น VIP เพื่อเข้าทันที",
    vipPerks: "ไม่ต้องเข้าคิว + ภาพคมชัด + เล่นได้นานขึ้น",
    sessionExpiredHint:
      "เซสชันมักหมดอายุหลังรอคิวนาน — แตะ \"ลองอีกครั้ง\" เพื่อเข้าคิวใหม่",
    lineOldUser: "คิวผู้เล่นเก่า",
    lineNewbie: "คิวผู้เล่นใหม่",
    lineFast: "คิวเร่งด่วน",
    lineSvip: "คิว SVIP",
    svipRequired: "เกมนี้สำหรับ SVIP เท่านั้น กรุณาอัปเกรดเป็น SVIP ก่อน",
    stageConnectingServer: "กำลังเชื่อมต่อเซิร์ฟเวอร์…",
    stageHandshake: "กำลังตรวจสอบกับเซิร์ฟเวอร์…",
    stageP2pNegotiating: "กำลังตั้งค่าการเชื่อมต่อ P2P…",
    stageMediaStreaming: "กำลังสตรีมภาพและเสียง…",
    stageWaitingFrame: "กำลังรอภาพ…",
    stageVideoTrack: "ได้รับแทร็กวิดีโอแล้ว…",
    stageEntered: "เชื่อมต่อแล้ว",
    stageConnect: "การเชื่อมต่อ",
    stageConnectedSoon: "เชื่อมต่อแล้ว — ภาพจะปรากฏในไม่ช้า…",
    allocFailed: "ไม่สามารถจัดสรรเซิร์ฟเวอร์เกมได้",
    allocFailedHttp: "การจัดสรรล้มเหลว (HTTP {status})",
    reenterHint: " (กรุณาออกแล้วเข้าเกมใหม่)",
    errP2pFailed: "เชื่อมต่อ P2P ล้มเหลว กรุณาตรวจสอบเครือข่ายของคุณ",
    errDisconnected: "การเชื่อมต่อหลุด (code={code}) กรุณาลองอีกครั้ง",
    errStageFailed: "{stage} ล้มเหลว",
    errStageFailedDetail: "{stage} ล้มเหลว: {detail}",
    errConnectTimeout:
      "การเชื่อมต่อหมดเวลา — ไม่สามารถติดต่อเซิร์ฟเวอร์ได้ ตรวจสอบเครือข่ายแล้วลองอีกครั้ง",
    errQueueCancelled: "เซิร์ฟเวอร์ยกเลิกคิวของคุณ กรุณาลองอีกครั้ง",
    errKicked:
      "บัญชีของคุณเข้าสู่ระบบบนอุปกรณ์อื่น เซสชันนี้จึงถูกตัดการเชื่อมต่อ",
    errCannotStart: "ไม่สามารถเริ่มเกมได้ในขณะนี้",
    registerFailed: "ลงทะเบียนล้มเหลว",
  },
  game: {
    recharge: "เติมเวลา",
    tabControl: "การควบคุม",
    tabFrame: "การแสดงผล",
    tabVoice: "เสียง",
    controlScheme: "โหมดควบคุม",
    hideVirtualKeys: "ซ่อนปุ่มเสมือน",
    mouseMode: "โหมดเมาส์",
    mouseModeTouchpad: "ทัชแพด",
    mouseModeDrag: "ลาก",
    mouseModeDirect: "ตรง",
    mouseSensitivity: "ความไวเมาส์ {n}%",
    rightStickMode: "โหมดสติ๊กขวา",
    joyModeFixed: "ตายตัว",
    joyModeHalf: "ครึ่งจอ",
    joyModeFull: "เต็มจอ",
    joyModeDrag: "ลาก",
    stickSensitivity: "ความไวสติ๊ก {n}%",
    customLayout: "ปรับแต่งผังปุ่ม",
    editLayout: "แก้ไขผัง",
    frameComingSoon:
      "การปรับขนาด / สลับคุณภาพการแสดงผลจะมาในเวอร์ชันถัดไป",
    gameSound: "เสียงเกม",
    schemeFollow: "ตามเกม",
    schemeGamepad: "จอย",
    schemeKeyMouse: "คีย์บอร์ดและเมาส์",
    schemeTouch: "ทัชสกรีน",
    schemeSwitchedGamepad: "สลับเป็นจอยแล้ว",
    schemeSwitchedKeyMouse: "สลับเป็นคีย์บอร์ดและเมาส์แล้ว",
    schemeSwitchedFollow: "กลับเป็นตามเกมแล้ว",
    modifierTitle: "ตัวปรับแต่ง",
    modifierNeedUnlock: "ต้องซื้อตัวปรับแต่งนี้เพื่อปลดล็อก",
    usageTitle: "วิธีใช้",
    usageEmpty: "ยังไม่มีวิธีใช้",
    gotIt: "เข้าใจแล้ว",
    close: "ปิด",
    noModifiers: "ไม่มีตัวปรับแต่ง",
    locked: "ล็อกอยู่",
    needUnlock: "ซื้อเพื่อปลดล็อก",
    remaining: "เหลือ {d}",
    use: "ใช้",
    quitTitle: "ออกจากเกม",
    quitConfirm: "ออกจากเกมปัจจุบัน?",
    quitConfirmBtn: "ออก",
    quitCancelBtn: "เล่นต่อ",
    joyNameFixed: "ตายตัว",
    joyNameHalfZone: "โซนครึ่งจอ",
    joyNameFullFollow: "ตามเต็มจอ",
    joyNameDrag: "ลาก",
    padConnected: "🎮 เชื่อมต่อจอยแล้ว ซ่อนปุ่มเสมือน",
    padDisconnected: "จอยถูกตัดการเชื่อมต่อ คืนค่าปุ่มเสมือน",
    rightStickToast: "สติ๊กขวา: {name}",
    noEditableLayout: "ไม่มีผังปุ่มที่แก้ไขได้",
    timeUsedUp: "เวลาเล่นหมดแล้ว",
    addTimeSuccess: "เพิ่มเวลาแล้ว",
    submitted: "ส่งแล้ว",
    minutesShort: "{n} นาที",
    addTime: "เพิ่มเวลา",
    expand: "ขยาย",
    collapse: "ย่อ",
    physicalPadConnected: "เชื่อมต่อจอยจริงแล้ว",
    unmute: "เปิดเสียง",
    mute: "ปิดเสียง",
    fullscreen: "เต็มจอ",
    summonKeyboard: "แสดงคีย์บอร์ด",
    sensoryMode: "การควบคุมด้วยการเคลื่อนไหว",
    idleWarnTip: "ไม่มีการใช้งาน จะออกจากเกมใน {n} วินาที",
    idleContinue: "เล่นต่อ",
    nsInputTitle: "เกมต้องการการป้อนข้อความ",
    nsInputHint: "พิมพ์ข้อความแล้วกดยืนยัน",
    settings: "ตั้งค่า",
    currentRemaining: "เหลือ {n} นาที",
    exchangeBeans: "แลกเวลาด้วยโทเคน",
    useAddTimeCard: "ใช้บัตรเพิ่มเวลา",
  },
  drama: {
    title: "ซีรีส์สั้น", refresh: "รีเฟรช", retry: "ลองอีกครั้ง", loadFailed: "โหลดซีรีส์ไม่สำเร็จ", completed: "จบแล้ว", episodes: "{n} ตอน", noMore: "ไม่มีเพิ่มเติม", loadMore: "โหลดเพิ่ม", back: "กลับ", episode: "ตอน {n}", episodesLabel: "ตอน", lockedTitle: "ปลดล็อกตอนนี้", lockedBody: "ปลดล็อกในแอปหลัก หรือดูโฆษณาเพื่อรับสิทธิ์ชั่วคราว", unlockEpisode: "ปลดล็อกตอน", watchAd: "ดูโฆษณา", adUnlocked: "ปลดล็อกตอนแล้ว", adUnavailable: "ยังไม่มีโฆษณา", paymentPending: "ชำระเงินให้เสร็จในแอปหลัก", paymentUnavailable: "ยังไม่สามารถชำระเงินได้", videoUnavailable: "วิดีโอไม่พร้อมใช้งาน",
  },
  net: {
    requestFailed: "คำขอล้มเหลว",
    errorWithCode: "ข้อผิดพลาด {code}",
    serverError: "ข้อผิดพลาดเซิร์ฟเวอร์ {status}",
    timeout: "คำขอหมดเวลา",
    networkError: "เครือข่ายผิดพลาด",
  },
  controls: {
    selectKeyFirst: "เลือกปุ่มก่อน",
    saved: "บันทึกแล้ว",
    saveFailed: "บันทึกล้มเหลว",
    selected: "เลือกแล้ว: {name}",
    keyFallback: "ปุ่ม",
    hint: "ลากเพื่อย้ายตำแหน่ง แตะเพื่อปรับขนาด / ความโปร่งใส / การทำงาน",
    size: "ขนาด {pct}%",
    opacity: "ความโปร่งใส {pct}%",
    operation: "การทำงาน",
    opPress: "กด",
    opDrag: "ลาก",
    opLock: "ล็อก",
    delete: "ลบ",
    addKey: "เพิ่มปุ่ม",
    reset: "รีเซ็ต",
    save: "บันทึก",
    addHiddenKey: "เพิ่มปุ่มที่ซ่อน",
    noHiddenKeys: "ไม่มีปุ่มที่ซ่อน",
  },
};

export default messages;
